// extracted by mini-css-extract-plugin
export default {"page":"i3hKO","page__header":"erdtg","page__content":"nCn7k","appear-from-above":"p1d29","appearFromAbove":"p1d29"};